export enum PermissionType {
    READ = 'READ',
    WRITE = 'WRITE',
    NO_ACCESS = 'NO_ACCESS',
    AUTHORIZED_READ = 'AUTHORIZED_READ',
    AUTHORIZED_WRITE = 'AUTHORIZED_WRITE',
    ALL_READ_AUTH_WRITE = 'ALL_READ_AUTH_WRITE',
    NONE_SELECTED = 'NONE_SELECTED'
}

export const BasicPermissionTypes = [
    PermissionType.READ,
    PermissionType.WRITE,
    PermissionType.NO_ACCESS
];

export const ProductionBasedPermissionTypes = [
    PermissionType.NO_ACCESS,
    PermissionType.AUTHORIZED_READ,
    PermissionType.READ,
    PermissionType.AUTHORIZED_WRITE,
    PermissionType.ALL_READ_AUTH_WRITE,
    PermissionType.WRITE
];
export const ReportBasedPermissionTypes = [
    PermissionType.NO_ACCESS,
    PermissionType.AUTHORIZED_READ,
    PermissionType.READ,
    PermissionType.AUTHORIZED_WRITE,
    PermissionType.ALL_READ_AUTH_WRITE,
    PermissionType.WRITE
];
